import { moduleProviderFactory } from "core/providers";
import {
    WoundOrderList,
    WoundOrderEdit,
    WoundOrderAddWoundDressingPage,
    WoundOrderEditWoundDetailsPage,
    DispensingOrderReviewPage,
} from "application/wound-order/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.wound-order",
                pattern: "/wound-order",
                children: [
                    {
                        name: "master.app.main.wound-order.list",
                        pattern: "",
                        tabTitle: "Wound order",
                        component: WoundOrderList,
                        authorization: "facilityOrderSection.read",
                        data: {
                            title: "Wound order",
                        },
                    },
                    {
                        name: "master.app.main.wound-order.create",
                        pattern: "/create",
                        tabTitle: "Create Wound Order",
                        component: WoundOrderEdit,
                        authorization: "facilityOrderSection.create",
                        data: {
                            title: "Create Wound Order",
                        },
                    },
                    {
                        name: "master.app.main.wound-order.add-wound-dressing",
                        pattern: "/create/:id",
                        tabTitle: "Wound Order",
                        authorization: "facilityOrderSection.create",
                        component: WoundOrderAddWoundDressingPage,
                        data: {
                            title: "Wound Order",
                        },
                    },
                    {
                        name: "master.app.main.wound-order.edit-wound-details",
                        pattern: "/edit-wound/:woundId",
                        tabTitle: "Edit Wound Details",
                        component: WoundOrderEditWoundDetailsPage,
                        data: {
                            title: "Edit Wound Details",
                        },
                    },
                    {
                        name: "master.app.main.wound-order.dispensing-order-review",
                        pattern: "dispensing-order-review/:woundOrderId",
                        tabTitle: "Dispensing Order Review",
                        component: DispensingOrderReviewPage,
                        data: {
                            title: "Dispensing Order Review",
                        },
                    },
                ],
            },
        ],
        menu: [
            {
                title: "MENU.FACILITY_ORDERS",
                icon: "package",
                authorization: 'administrationSection.read',
                order: 5,
                subMenu: [
                    {
                        title: "Wound Care",
                        authorization: 'administrationSection.read',
                        route: "master.app.main.wound-order.list",
                        order: 10,
                    },
                ],
            },
        ],
    });
})();
